import { Injector } from '@angular/core';
import { PackageType, PackageTypes } from '../package-type';
import { BillingType } from '../billing-type';
import { CentralBillingUnitModuleModel } from '../billing-central/central-billing-unit-module.model';

export class BillingUnitModuleModel extends CentralBillingUnitModuleModel {
    CentralPackageType = PackageType.Free;
    CentralPackageTypeName = '';
    CentralIsEnabled = false;
    CentralIsEnabledText = '';

    constructor(data, injector: Injector) {
        super(data, injector);
    }

    Initialize(data) {
        Object.assign(this, data);
        super.Initialize(data);

        this.CentralPackageTypeName = '-';

        if (this.AllowSelectLevel) {
            const centralPackageTypeName = PackageTypes.find((item) => item.Id === data.CentralPackageType);
            this.CentralPackageTypeName = centralPackageTypeName
                ? this.appTextService.get(centralPackageTypeName.TextId)
                : 'Unknown package type';
        }

        this.CentralIsEnabledText = '-';
        if (this.CanTurnModuleOff) {
            if (this.CentralIsEnabled) {
                this.CentralIsEnabledText = this.appTextService.get('on');
            } else {
                this.CentralIsEnabledText = this.appTextService.get('off');
            }
        }

        if (this.BillingType == BillingType.Central && this.PackageType < this.CentralPackageType)
            this.PackageType = this.CentralPackageType;
    }
}
